<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid" id="blurry">
    <div class="row signup-page">
      <div class="circle_background_mob"> </div>
      <div class="col-lg-12">
        <div class="signup-page--right whiteandround">
          <div class="login-form" v-if="!hasHE">
<!--            <div class="logo_form">-->
<!--              <img :src="getTranslations.logo_for_branded_projects || 'static/images/Swipo_logo_02.png'" alt="">-->
<!--            </div>-->
            <div class="form_title">
              <h1>{{ getTranslations.visitor_sign_up_1_single_country_register_in_steps }}</h1>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="StandardRegSteps_Container" v-if="!hasHE && !hasStepsToDisplay">
              <div class="StandardRegSteps_step">1</div>
              <div class="StandardRegSteps_step inactive">2</div>
              <div class="StandardRegSteps_step inactive">3</div>
            </div>
            <div class="twoStepRegSteps_Container" v-else>
              <div class="twoStepRegSteps_step">1</div>
              <div class="twoStepRegSteps_step inactive">2</div>
            </div>
          </div>
          <div class="signup-form">
            <div class="form-help extra_padng">

              <div class="operators_selection_wrap" v-if="multiOperatorInfo.multiOperatorEnabled  && showOperators()">
                <p class="center">{{ getTranslations.visitor_sign_up_1_single_country_my_operator }} </p>
                <div class="operators_radio">
                  <label v-for="(operator, index) in multiOperatorInfo.multiOperatorKeys"
                         class="operators_radio operators_radio_inline" :key="index"
                         v-if="multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage[index]">
                    <img class="operators_icon" :src="getOperatorImage(index)" :alt="getOperatorDisplayName(index)">
                    <input type="radio" name="operator" :value="operator" v-model="operatorPicked"
                           @click="check();getOrdinalByOperator(operator);">
                    <span></span>
                  </label>
                </div>
                <div class="operators_error_msg" v-if="!operatorPicked && btnSubmitted"><span
                  class="form-group__feedback">{{ getTranslations.visitor_sign_up_1_single_country_select_operator }}</span></div>
              </div>
              <div v-else-if="isBrandedProject">
                <img class="operator_register_promo_logo" :src="operatorLogoForBrandedProject">
              </div>
              <div v-else>
                <img class="form-help__icon" src="static/images/mobile-icon.svg" @error="imageErrorHandler" alt="">
              </div>

              <p>{{ getTranslations.visitor_sign_up_1_single_country_info_msg_enter_msisdn }}</p>
            </div>

            <form action="">
              <div class="form-group"
                   :class="[ !hasErrors ? '' : 'has-warning' ]">
                <input type="text" class="mobile form-group__textfield phone_input"
                       id="msisdnInputField"
                       :readOnly="!!hasHE"
                       :class="[ !hasErrors ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_1_single_country_placeholder"
                       @keyup="check" v-model="user.msisdn"/>
                <span v-show="getMessage(message) && user.msisdn" class="form-group__feedback">{{ getMessage(message) }}</span>
              </div>

              <div v-if="!hasHE" class="form-footer">
                {{ getTranslations.visitor_sign_up_3_info_msg_agree_to_terms }} <br><a>
                <p v-if="showDisclaimerNotice() && !hasHE && !validationForOneTimeSubscription">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_free_for') }}</p>
                <a
                  :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')"
                  target="_blank">{{ getTranslations.visitor_sign_up_3_terms_and_conditions }}</a>
              </a>
              </div>
              <input type="submit" v-if="!validationForOneTimeSubscription"
                       :value="(!hasHE) ? getTranslations.visitor_sign_up_1_single_country_submit_button_continue : getTranslations.visitor_sign_up_2_submit_button_continue"
                       :class="['btn btn--medium btn--main ', ( (hasErrors || waitForResponse)? 'deactivated' : '')]"
                       @click.prevent="onSubmitAction">
              <input v-if="validationForOneTimeSubscription" type="submit" :value="getTranslations.visitor_sign_up_1_single_placeholder_daily_subscription"
                     :class="['one_time btn btn--medium btn--main', ( (hasErrors || waitForResponse)? 'deactivated' : '')]"
                     @click.prevent="onSubmitActionForSubscriptionButtons(true)">
              <input v-if="validationForOneTimeSubscription" type="submit"
                     :value="getTranslations.visitor_sign_up_1_single_placeholder_one_time_subscription"
                     :class="['one_time btn btn--medium btn--main', ( (hasErrors || waitForResponse)? 'deactivated' : '')]"
                     @click.prevent="onSubmitActionForSubscriptionButtons(false)">

                <p>
                  {{ getTranslations.visitor_sign_up_1_single_country_already_have_account }}
                  <router-link :to="'login'">{{ getTranslations.visitor_sign_up_1_single_country_login }}</router-link>
                </p>
              <div v-if="hasSimplify()"
                class="form-footer-text">
                <span v-for="(key, index) in disclaimers"
                    v-if="getTranslations[key]"
                    :key="index">
                  {{ getTranslations[key] }}
                </span>
              </div>
              <div class="form-footer-text" v-if="showDisclaimer()">
                {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer') }}
              </div>
              <div class="form-footer" v-if="validationForOneTimeSubscription">
                <p>{{ getTranslations.visitor_sign_up_1_single_country_for_daily_sub }}</p>
                <p>{{ getTranslations.visitor_sign_up_1_single_country_for_one_time }}</p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <simplify-registration v-if="showSimpleRegistrationModal"
                           @close="showSimpleRegistrationModal = false;">
    </simplify-registration>
    <confirmation v-if="showConfirmationModal"
                  @confirm="showConfirmationModal = false;getNextVerificationStep()();"
                  @close="showConfirmationModal = false;">
    </confirmation>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import FlowMixin from '@/common/mixins/flow';
import confirmation from '@/components/home/modals/Confirm';
import simplifyRegistration from '@/components/home/modals/SimplifyRegistration';

export default {
  name: 'sign-up-1-single-country',
  components: { confirmation, simplifyRegistration },
  mixins: [IntegrationMixin, FlowMixin],
  data() {
    return {
      operatorLogoForBrandedProject: '',
      btnSubmitted: false,
      operatorPicked: '',
      showSimpleRegistrationModal: false,
      user: {
        msisdn: '',
        hash: '',
      },
      message: '',
      hasErrors: false,
      defaultImagePath: '/ext/banners/RegistrationDefault.png',
      imageUsed: '',
      waitForResponse: false,
      showConfirmationModal: false,
      hasStepsToDisplay: false,
      validationForOneTimeSubscription: null,
      disclaimers: ['visitor_sign_up_disclaimer_text1', 'visitor_sign_up_disclaimer_text2', 'visitor_sign_up_disclaimer_text3'],
    };
  },
  created() {
    this.hasStepsToDisplay = this.hasSteps();
    const numOfVisibleOperators = (this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.filter(item => item)).length;
    if (numOfVisibleOperators === 1) {
      const position = this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.indexOf(true);
      const operator = this.multiOperatorInfo.multiOperatorKeys[position];
      this.storeOperator(operator);
      this.operatorPicked = operator;
    }
    if (this.$route.query.errorMessage) this.message = this.getTranslatedErrorMessage(this.$route.query.errorMessage);
    if (this.message) {
      this.user.msisdn = this.$route.query.errorMsisdn || '';
      this.hasErrors = true;
    } else if (this.getIntegrationByName()) {
      this.user.msisdn = this.$route.query.heMsisdn || '';
      this.user.hash = this.$route.query.heHash || '';
      this.setCorrelationId({ value: this.$route.query.cid || '' });
      this.$nextTick(() => {
        this.hasHE = this.user.msisdn && this.user.hash && this.isSingleOptIn();
      });
    }
    this.imageUsed = this.banner ? `/ext/banners/${this.banner}.jpg` : this.defaultImagePath;
    this.validationForOneTimeSubscription = (!this.getIntegrationByName()) ? false : this.getIntegrationByName().value.oneTimeSubscription;
    this.operatorLogoForBrandedProject = this.isBrandedProject ? `static/skins/skin_${this.duelSkin.toString()}/images/logo-operator.svg` || 'static/images/logo-operator.svg' : '';
  },
  methods: {
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapMutations('common', [
      'updateMultiOperatorOrdinal',
      'setDefaultDailySubButtonEnabled',
      'setCorrelationId',
    ]),
    ...mapActions('common', [
      'storeOperator',
    ]),
    onSubmitActionForSubscriptionButtons(isDailySubscription) {
      this.setDefaultDailySubButtonEnabled(isDailySubscription);
      this.btnSubmitted = true;
      if (isDailySubscription) {
        this.checkButton(isDailySubscription);
      } else {
        const showModal = (!this.getIntegrationByName()) ? false : this.getIntegrationByName().value.showRegistrationModal;
        if (showModal) {
          this.showSimpleRegistrationModal = true;
        } else {
          this.checkButton(isDailySubscription);
        }
      }
    },
    showOperators() {
      const activeIntegration = this.getIntegrationByName();
      return !activeIntegration || !activeIntegration.value.affectsMultiOperator;
    },
    showDisclaimerNotice() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.operatorPicked;
      }
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_free_for');
    },
    showDisclaimer() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.operatorPicked;
      }
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer');
    },
    getOrdinalByOperator(operator) {
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((res) => {
        this.updateMultiOperatorOrdinal({ value: res.data.data.multiOperatorOrdinal });
      });
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    getTranslatedErrorMessage(errorMessage) {
      switch (errorMessage) {
      case 'MSISDN_INVALID': return 'visitor_sign_up_invalid_msisdn_msg';
      case 'ALREADY_REGISTERED': return 'visitor_sign_up_msisdn_already_registered';
      case 'MSISDN_NOT_EXIST': return 'visitor_sign_up_msisdn_not_exists';
      case 'MSISDN_BLACKLISTED': return 'visitor_sign_up_msisdn_blacklisted';
      case 'BLOCKED_USER': return 'visitor_forgot_password_warning_msd_max_attempts';
      case 'CAMPAIGN_CLOSED': return 'visitor_sign_up_campaign_closed';
      case 'SERVER_ERROR': return 'home_profile_profile_edit_server_unvailable';
      default: return 'visitor_sign_up_warning_third_party_error';
      }
    },
    getOperatorImage(operatorIndex) {
      return this.getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    imageErrorHandler() {
      this.imageUsed = this.defaultImagePath;
    },
    check() {
      const validMsisdnRegex = /^[0-9]||[()+-]{0,20}$/;
      const validMsisdn = this.user.msisdn.match(validMsisdnRegex);
      if (!validMsisdn) {
        this.message = 'visitor_sign_up_invalid_msisdn_msg';
        this.hasErrors = true;
      } else {
        sessionStorage.setItem('msisdn', this.user.msisdn);
        this.hasErrors = false;
        this.message = '';
      }
    },
    mapErrorMessages(resMessage) {
      if (resMessage === 'MSISDN_INVALID') {
        this.message = 'visitor_sign_up_invalid_msisdn_msg';
      } else if (resMessage === 'ALREADY_REGISTERED') {
        this.message = 'visitor_sign_up_msisdn_already_registered';
      } else if (resMessage === 'MSISDN_NOT_EXIST') {
        this.message = 'visitor_sign_up_msisdn_not_exists';
      } else if (resMessage === 'MSISDN_BLACKLISTED') {
        this.message = 'visitor_sign_up_msisdn_blacklisted';
      } else if (resMessage === 'BLOCKED_USER') {
        this.message = 'visitor_forgot_password_warning_msd_max_attempts';
      } else if (resMessage === 'CAMPAIGN_CLOSED') {
        this.message = 'visitor_sign_up_campaign_closed';
      } else if (resMessage === 'SERVER_ERROR') {
        this.message = 'home_profile_profile_edit_server_unvailable';
      } else if ((resMessage === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resMessage === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resMessage === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
        this.message = 'visitor_sign_up_warning_third_party_error';
      }
    },
    onSubmitAction() {
      this.btnSubmitted = true;
      if (!this.multiOperatorInfo.multiOperatorEnabled || (this.multiOperatorInfo.multiOperatorEnabled && this.operatorPicked)) {
        this.checkButton();
      } else {
        this.hasErrors = true;
      }
    },
    checkButton(isDailySubscription) {
      const activeIntegration = this.getIntegrationByName();
      if (activeIntegration && activeIntegration.value.hasConfirmation && this.isSingleOptIn()) {
        this.showConfirmationModal = true;
      } else {
        let appropriateRequestPinStep = this.getAlternateRequestPinAction(isDailySubscription); // integration specific
        if (!appropriateRequestPinStep) {
          appropriateRequestPinStep = this.getNextVerificationStep()(); // flow specific (default)
        }
        appropriateRequestPinStep.call(this);
      }
    },
  },
  computed: {
    ...mapState('common', [
      'duelSkin',
      'banner',
      'isBrandedProject',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/SignUp1SingleCountry.vue